import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  HostListener,
  inject,
  input,
  signal,
} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {Router} from '@angular/router';
import {ButtonType, CovButtonComponent, CovIconComponent, IconName} from '@cov/ui-angular';
import {TranslocoPipe} from '@jsverse/transloco';
import {ASM} from '../../../../shared/constants';
import {AsmService} from '../../../../shared/services/asm.service';
import {UserService} from '../../../../shared/services/user.service';

@Component({
  selector: 'cov-asm-impersonate-user-information',
  imports: [TranslocoPipe, CovButtonComponent, CovIconComponent],
  templateUrl: './asm-impersonate-user-information.component.html',
  styleUrl: './asm-impersonate-user-information.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsmImpersonateUserInformationComponent {
  // SERVICES
  private readonly asmService = inject(AsmService);
  private readonly userService = inject(UserService);
  private readonly router = inject(Router);
  private readonly elementRef = inject(ElementRef);

  // INPUT
  expanded = input.required<boolean>();

  // STATE
  impersonatedUser = toSignal(this.asmService.getImpersonateUser());
  asmUser = this.asmService.asmUser;
  infoVisible = signal(false);

  // CONST
  protected readonly ButtonType = ButtonType;
  protected readonly IconName = IconName;

  constructor() {
    effect(() => {
      if (this.expanded()) {
        this.infoVisible.set(false);
      }
    });
  }

  public endSession(): void {
    this.asmService.stopImpersonateSession();
    this.asmService.clearImpersonateUser();
    this.userService.clearCurrentUser();
    this.router.navigate([ASM]);
  }

  @HostListener('document:click', ['$event'])
  protected onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.infoVisible.set(false);
    }
  }

  protected toggleImpersonatedInfo(): void {
    this.infoVisible.update((visible) => !visible);
  }
}
